global.modules.set({
  async init(context) {
    $('[type="radio"]', context).each(function() {
      var item = $(this);
      var name = item.attr('name');
      var form = item.attr('form') ? $('form#' + item.attr('form')).closest('form') : $(this).closest('form');
      item.parent().on('click', function() {
        if($(this).data('toggle') && $(this).hasClass('active')) {
          $(this).find(`[name="${name}"]`).prop('checked', false).parent().removeClass('active');
          return;
        }
        form.find(`[name="${name}"]`).parent().removeClass('active');
        form.find(`[name="${name}"]`).removeAttr('checked')
        $(this).addClass('active');
        item.prop('checked', true).trigger('change');
      })
    })
  }
})